import { Box } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";
import homeIcon1 from "../../assets/images/home-icon-1.svg";
import homeIcon2 from "../../assets/images/home-icon-2.svg";
import homeIcon3 from "../../assets/images/home-icon-3.svg";
import homeIcon8 from "../../assets/images/home-quick-1.svg";
import homeIcon9 from "../../assets/images/home-quick-2.svg";
import homeIcon10 from "../../assets/images/home-quick-3.svg";
import homeIcon5 from "../../assets/images/home-shortcut-1.svg";
import homeIcon6 from "../../assets/images/home-shortcut-2.svg";
import homeIcon7 from "../../assets/images/home-shortcut-3.svg";
import progressShape from "../../assets/images/progress-bar-shape.svg";
import Modal from "../../components/Modal/Modal";
import { getProductRequest } from "../../store/shopping/shopping.actions";
import ShoppingAPI from "../../store/shopping/shopping.api";
import { getProducts } from "../../store/shopping/shopping.selector";
import { fetchLiveStreamRequest } from "../../store/social/social.actions";
import { getLiveStreams } from "../../store/social/social.selector";
import { getUserProfile } from "../../store/user/user.selector";
import ProductCard from "../livestream/product_card";
import feedback1 from "../../assets/images/feedback1.svg";
import feedback2 from "../../assets/images/feedback2.svg";
import feedback3 from "../../assets/images/feedback3.svg";
import feedback4 from "../../assets/images/feedback4.svg";
import feedback5 from "../../assets/images/feedback5.svg";
import MyRecordings from "../Profile/MyRecordings";

const Home = () => {
    const dispatch = useDispatch();
    const [inviteModal, setInviteModal] = useState(false);
    const [addProduct, setAddProduct] = useState(false);
    const [balance, setBalance] = useState({
        amount: 0.0,
        currency: "MYR",
    });

    const navigate = useNavigate();

    const { userProfile, livestreams, products } = useSelector((state) => {
        return {
            userProfile: getUserProfile(state),
            livestreams: getLiveStreams(state),
            products: getProducts(state),
        };
    });

    useEffect(() => {
        setAddProduct(false);
    }, [products]);

    useEffect(() => {
        dispatch(fetchLiveStreamRequest("?where=owner:" + userProfile._id));
    }, [userProfile]);

    useEffect(() => {
        if (livestreams.length > 10) {
            setInviteModal(true);
        }
    }, [livestreams]);

    useEffect(() => {
        dispatch(getProductRequest(userProfile._id));
        ShoppingAPI.GetUserTransactions("")
            .then((x) => {
                let data = x.data
                    .filter(
                        (x) =>
                            x.payoutStatus === undefined ||
                            x.payoutStatus === "Initiated"
                    )
                    .map((x) => x.netAmount)
                    .reduce((partial_sum, a) => partial_sum + a, 0);
                setBalance({
                    amount: data,
                    currency:
                        x.data.length > 0
                            ? x.data[0].currency.toUpperCase()
                            : "MYR",
                });
            })
            .catch((x) => {
                setBalance({
                    amount: 0.0,
                    currency: "MYR",
                });
            });
    }, []);

    return (
        <div className="px-2 sm:px-4 lg:px-8 py-7">
            <Modal show={addProduct} onClose={() => setAddProduct(false)}>
                <ProductCard
                    products={products}
                    product={{}}
                    isAdd={true}
                    onClose={() => setAddProduct(false)}
                />
            </Modal>
            <div className=" mb-[17px]  text-white p-4 rounded-lg gap-y-4 bg-primary"
                style={{
                    maxHeight: 200,
                    position: "relative",
                    marginBottom: 120
                }}>
                <div className="flex flex-col sm:flex-row items-center justify-between">
                    <h1 className="text-2xl font-bold text-white-color">
                        👋 Hello, {userProfile.fullName}
                    </h1>
                    <div className="flex items-center justify-between">
                        <button
                            className="py-2.5 px-5 mx-2 text-sm rounded-lg border border-black-10 bg-white text-black-50 font-medium capitalize"
                            onClick={() => navigate("/page/viewStore")}
                        >
                            Go&nbsp;to&nbsp;Store
                        </button>
                        {userProfile.role !== "Pro" && (
                            <button
                                onClick={() => navigate("/page/upgradePlan")}
                                className="py-2.5 px-5 bg-orange-color text-white text-sm font-bold capitalize rounded-lg whitespace-nowrap w-full sm:w-fit"
                            >
                                Upgrade Plan
                            </button>
                        )}
                    </div>
                </div>
                <p className="py-2">Your trial period will expire in 2 days. Get PRO now.</p>
                <p className="py-2" >Quick start using some templates</p>
                <Box display="flex" justifyContent="space-around">
                    <img src={feedback1} width="19%" />
                    <img src={feedback2} width="19%" />
                    <img src={feedback3} width="19%" />
                    <img src={feedback4} width="19%" />
                    <img src={feedback5} width="19%" />
                </Box>
            </div>
            {/* <div className="p-4 bg-white rounded-lg mb-6">
                <Modal
                    show={inviteModal && userProfile.role !== "Pro"}
                    onClose={() => setInviteModal(false)}
                >
                    <div className="max-w-[437px]">
                        <img
                            onClick={() => setInviteModal(false)}
                            src={congrats}
                            className="max-w-[380px] w-full sm:px-3"
                            alt=""
                        />
                    </div>
                </Modal> 
                <div className="flex items-center justify-between">
                    <h3 className="text-base font-medium text-ebony-color mb-2.5">
                        Your progress
                    </h3>
                    <p className="text-black-60 text-sm font-normal">
                        {livestreams.length}/{500}
                    </p>
                </div>
                <p className="text-base text-black-60 font-normal">
                    Achieve goal by starting 10 videos to unlock 3 months free
                    PRO
                </p>

                <div className="w-full bg-[#E38301]/5 rounded-full h-[17px] mb-4 mt-2">
                    <div
                        className={`h-[17px] rounded-full relative bg-center bg-repeat-x bg-opacity-70`}
                        style={{
                            background: `linear-gradient(270.01deg, #FFBA5B -0.26%, #E38301 99.99%), url('${progressShape}')`,
                            width: `${progress}%`,
                        }}
                    >
                        <div className="w-[25px] aspect-square rounded-full bg-[#E38301] progress-shadow absolute top-2/4 -translate-y-2/4 right-0 flex justify-center items-center">
                            <span className="block bg-white w-3 aspect-square rounded-full"></span>
                        </div>
                    </div>
                </div>
                <div className="w-full flex justify-between text-black-50 mt-1.5 text-sm">
                    <p>0</p>
                    <p>2</p>
                    <p>4</p>
                    <p>6</p>
                    <p>8</p>
                    <p>10</p>
                </div>
            </div> */}
            <div className="mb-6">
                <h3 className="text-base text-black-500 text-bold capitalize my-4 pt-4">
                    Recent Videos
                </h3>
                <MyRecordings isHome={true} />
            </div>
            <div className="mb-6">
                <h3 className="text-base text-ebony-color font-medium capitalize mb-2">
                    Shortcut
                </h3>
                <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 lg:grid-cols-none lg:flex lg:flex-wrap gap-4">
                    <div className="bg-white rounded-lg border border-black-10 w-full lg:min-w-[267px] min-h-[88px] lg:w-[270px] flex  justify-start items-center mx-auto sm:mx-0 px-[22px]">
                        <NavLink onClick={() => setAddProduct(true)}>
                            <div className="flex items-center gap-6">
                                <img
                                    src={homeIcon5}
                                    alt=""
                                    className="w-[30px] h-[30px]"
                                />
                                <p className="text-base font-bold text-ebony-color">
                                    Upload new product
                                </p>
                            </div>
                        </NavLink>
                    </div>
                    <div className="bg-white rounded-lg border border-black-10 w-full lg:min-w-[267px] min-h-[88px] lg:w-[270px] flex  justify-start items-center mx-auto sm:mx-0 px-[22px]">
                        <NavLink to="/page/account">
                            <div className="flex items-center gap-6">
                                <img
                                    src={homeIcon6}
                                    alt=""
                                    className="w-[30px] h-[30px]"
                                />
                                <p className="text-base font-bold text-ebony-color">
                                    Manage my account
                                </p>
                            </div>
                        </NavLink>
                    </div>
                    <div className="bg-white rounded-lg border border-black-10 w-full lg:min-w-[267px] min-h-[88px] lg:w-[270px] flex  justify-start items-center mx-auto sm:mx-0 px-[22px]">
                        <NavLink to="/page/account/payment">
                            <div className="flex items-center gap-6">
                                <img
                                    src={homeIcon7}
                                    alt=""
                                    className="w-[30px] h-[30px]"
                                />
                                <p className="text-base font-bold text-ebony-color">
                                    Set up payment method
                                </p>
                            </div>
                        </NavLink>
                    </div>
                </div>
            </div>

            <div className="mb-6">
                <h3 className="text-base text-ebony-color font-medium capitalize mb-2">
                    Getting started
                </h3>
                <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 lg:grid-cols-none lg:flex lg:flex-wrap gap-4">
                    <div className="bg-white rounded-lg border border-black-10 lg:w-[270px] flex flex-col justify-between mx-auto sm:mx-0">
                        <div className="px-4 pt-4 flex flex-col items-center text-center">
                            <img src={homeIcon1} alt="" className="mb-6" />
                            <h3 className="text-base font-bold text-ebony-color mb-2.5">
                                Tips on using Ulalive
                            </h3>
                            <p className="text-sm text-ebony-color/60 font-medium mb-9">
                                Watch a collection of video demos on how to make
                                full use of Ulalive{" "}
                            </p>
                        </div>
                        <div className="bg-ebony-color/5 py-2 px-4 flex justify-end rounded-bl-lg rounded-br-lg">
                            <Link
                                to={"/page/youtubeVideos#PLAfUEi8pxyOc3N1JOsXhBJKkSOh07EA7S"}
                                className="text-sm font-medium text-orange-color"
                            >
                                Learn more
                            </Link>
                        </div>
                    </div>
                    <div className="bg-white rounded-lg border border-black-10 lg:w-[270px] flex flex-col justify-between mx-auto sm:mx-0">
                        <div className="px-4 pt-4 flex flex-col items-center text-center">
                            <img src={homeIcon2} alt="" className="mb-6" />
                            <h3 className="text-base font-bold text-ebony-color mb-2.5">
                                What's new
                            </h3>
                            <p className="text-sm text-ebony-color/60 font-medium mb-9">
                                Read the latest news, official updates, and
                                features directly from the headquarters.
                            </p>
                        </div>
                        <div className="bg-ebony-color/5 py-2 px-4 flex justify-end rounded-bl-lg rounded-br-lg">
                            <Link
                                to={"/page/youtubeVideos#PLAfUEi8pxyOcnSASQ9lWb-Ja42vZ1gD48"}
                                className="text-sm font-medium text-orange-color"
                            >
                                Learn more
                            </Link>
                        </div>
                    </div>
                    <div className="bg-white rounded-lg border border-black-10 w-full lg:w-[270px] flex flex-col justify-between mx-auto sm:mx-0">
                        <div className="px-4 pt-4 flex flex-col items-center text-center">
                            <img src={homeIcon3} alt="" className="mb-6" />
                            <h3 className="text-base font-bold text-ebony-color mb-2.5">
                                Invite your friends to Ulalive
                            </h3>
                            <p className="text-sm text-ebony-color/60 font-medium mb-9">
                                Get a FREE PRO access for 14 days when you
                                invite a friend to sign up for Ulalive.
                            </p>
                        </div>
                        <div className="bg-ebony-color/5 py-2 px-4 flex justify-end rounded-bl-lg rounded-br-lg">
                            <Link
                                to={"/page/refer"}
                                className="text-sm font-medium text-orange-color"
                            >
                                Learn more
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            {/* <div className="mb-6">
                <h3 className="text-base text-ebony-color font-medium capitalize mb-2">
                    Explore more
                </h3>
                <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 lg:grid-cols-none lg:flex lg:flex-wrap gap-4">
           
                    <div className="bg-white rounded-lg border border-black-10 w-full lg:w-[270px] flex flex-col justify-between mx-auto sm:mx-0">
                        <div className="px-4 pt-4 flex flex-col items-center text-center">
                            <img src={homeIcon4} alt="" className="mb-6" />
                            <p className="text-sm font-medium text-ebony-color/60">
                                Fund available
                            </p>
                            <h3 className="text-base font-bold text-ebony-color mb-2.5">
                                {balance.currency} {balance.amount.toFixed(2)}
                            </h3>
                            <Link
                                to="/page/account/withdrawal"
                                className="text-sm font-medium text-[#7900F8]"
                            >
                                Payment account
                            </Link>
                            <Link
                                to="/page/account/withdrawal"
                                className="text-sm font-medium text-[#7900F8]"
                            >
                                Manage subscription
                            </Link>
                        </div>
                        <div className="bg-ebony-color/5 py-2 px-4 flex justify-end rounded-bl-lg rounded-br-lg">
                            <Link
                                to="/page/account/withdrawal"
                                className="text-sm font-medium text-orange-color"
                            >
                                Learn more
                            </Link>
                        </div>
                    </div>
                    <div className="bg-white rounded-lg border border-black- w-full lg:w-[270px] flex flex-col justify-between mx-auto sm:mx-0">
                        <div className="px-4 pt-4 flex flex-col items-center text-center">
                            <img src={homeSocial} alt="" className="" />
                            <h3 className="text-base font-bold text-ebony-color mb-2.5">
                                Integrate these incredible apps into your web
                                store to maximise its potential.
                            </h3>
                        </div>
                        <div className="bg-ebony-color/5 py-2 px-4 flex justify-end rounded-bl-lg rounded-br-lg">
                            <Link
                                to={"/"}
                                className="text-sm font-medium text-orange-color"
                            >
                                Learn more
                            </Link>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="mb-6">
                <h3 className="text-base text-ebony-color font-medium capitalize mb-2">
                    Quick stats
                </h3>
                <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-3 lg:grid-cols-none lg:flex lg:flex-wrap gap-4">
                    <div className="bg-white rounded-lg border border-black-10 w-full lg:min-w-[267px] min-h-[88px] lg:w-[270px] flex  justify-start items-center mx-auto sm:mx-0 px-[22px]">
                        <div className="flex items-center gap-[22px]">
                            <img
                                src={homeIcon8}
                                alt=""
                                className="w-[30px] h-[30px]"
                            />
                            <div className="">
                                <p className="text-sm font-medium text-black-60">
                                    Total visitors
                                </p>
                                <p className="text-base font-bold text-ebony-color">
                                    {livestreams
                                        .map((x) => x.totalWatch)
                                        .reduce(
                                            (partialSum, a) => partialSum + a,
                                            0
                                        )}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="bg-white rounded-lg border border-black-10 w-full lg:min-w-[267px] min-h-[88px] lg:w-[270px] flex  justify-start items-center mx-auto sm:mx-0 px-[22px]">
                        <div className="flex items-center gap-[22px]">
                            <img
                                src={homeIcon9}
                                alt=""
                                className="w-[30px] h-[30px]"
                            />
                            <div className="">
                                <p className="text-sm font-medium text-black-60">
                                    Total store views
                                </p>
                                <p className="text-base font-bold text-ebony-color">
                                    {livestreams
                                        .map((x) => x.guestInfo.length)
                                        .reduce(
                                            (partialSum, a) => partialSum + a,
                                            0
                                        )}
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="bg-white rounded-lg border border-black-10 w-full lg:min-w-[267px] min-h-[88px] lg:w-[270px] flex  justify-start items-center mx-auto sm:mx-0 px-[22px]">
                        <div className="flex items-center gap-[22px]">
                            <img
                                src={homeIcon10}
                                alt=""
                                className="w-[30px] h-[30px]"
                            />
                            <div className="">
                                <p className="text-sm font-medium text-black-60">
                                    Average time spent
                                </p>
                                <p className="text-base font-bold text-ebony-color">
                                    {(
                                        livestreams
                                            .filter((x) => x.durationTime)
                                            .map((x) => x.durationTime)
                                            .reduce(
                                                (partialSum, a) =>
                                                    partialSum + a,
                                                0
                                            ) / 3600
                                    ).toFixed(2)}{" "}
                                    hours
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;
